import { apiAuth } from "../../api/api-auth";

export default{
  state: {
    auth_data: {}
  },

  mutations: {
    set_user(state, payload){
      state.auth_data = payload;
    },
    
    set_local_storage_auth_data(state){
      const payload = JSON.stringify(state.auth_data);
      localStorage.setItem('auth_data', payload);
    },

    clear_local_storage(state){
      localStorage.removeItem('auth_data');
      state.auth_data = {}
    }

  },

  actions: {

    async login({commit, dispatch}, payload){
      const result = await apiAuth.login(payload);
      commit('set_user', result);
      await dispatch('update_storage');
    },

    async update_storage({commit}){   
      commit('set_local_storage_auth_data');
    },

    async check_local_storage({commit}){
      const auth_data = localStorage.getItem('auth_data');
      commit('set_user', JSON.parse(auth_data));
    },

    async logout({commit}){
      commit('clear_local_storage');
    }

  },

  getters: {

    user(state){
      return state.auth_data?.user
    }

  }
}